import { useEffect, useRef } from "react";

// Fascia "Ai VESTA" in Home: slogan + logo animato (video dell'intro) che si riaccende ogni 10 secondi.
// Tutta la fascia è un pulsante: toccandola si aprono i racconti di Vesta.
export function VestaSlot({ onInfo }) {
  const v = useRef(null);
  useEffect(() => {
    const t = setInterval(() => { const x = v.current; if (x && x.paused) { x.currentTime = 0; x.play().catch(() => {}); } }, 10000);
    return () => clearInterval(t);
  }, []);
  return (
    <button type="button" onClick={onInfo} aria-label="Scopri Vesta"
      className="relative flex w-full items-center gap-3 overflow-hidden rounded-[1.6rem] bg-black px-3 py-3 text-left shadow-lg transition-transform active:scale-[0.97]" data-testid="cliente-vesta-slot">
      <span className="relative h-14 w-20 shrink-0 overflow-hidden rounded-2xl bg-black">
        <video ref={v} autoPlay muted playsInline preload="auto" className="h-full w-full scale-[1.35] object-cover" data-testid="cliente-vesta-slot-logo">
          <source src="/ai-vesta-animazione.mp4" type="video/mp4" />
          <source src="/ai-vesta-animazione.webm" type="video/webm" />
        </video>
      </span>
      <span className="min-w-0 flex-1">
        <b className="block text-[15px] font-extrabold leading-tight text-white" data-testid="cliente-vesta-slot-slogan">
          Per essere l'<span className="text-[#C17F59]">1%</span> devi fare quello che il 99% non fa.
        </b>
        <span className="mt-1 block text-[10px] font-semibold uppercase tracking-widest text-neutral-500">Ai VESTA · tecnologia TORRI</span>
      </span>
    </button>
  );
}

export const RACCONTI_VESTA = [
  { id: "chi", label: "Chi è Vesta", testo: "Presentati: dimmi chi sei, chi ti ha creata e perché ti chiami Vesta." },
  { id: "storia", label: "La storia di TORRI", testo: "Raccontami la storia di TORRI." },
  { id: "prisma", label: "Tecnologia PRISMA\u00a04.0", testo: "Cos'è la tecnologia PRISMA 4.0 dei pannelli TORRI?" },
  { id: "xcore", label: "Tecnologia X-CORE²", testo: "Cos'è la tecnologia X-CORE² dei pannelli TORRI?" },
];
